import React from 'react';
import PropTypes from 'prop-types';
import { payeePropTypes } from '../../../sharedComponents/FromToPayeeSelector/propTypes';
import PayeeCardSelector from './PayeeCardSelector';

// TODO: render different Payee cards based on payee type.
const PayeePickerPage = ({
	pageLoading = false,
	payees,
	listViewSelected,
	handlePayeeSelect,
	cardClass,
	getIsPayeeSelected,
	isManageYourPayee,
	handleViewPayee,
	handleDeletePayee,
	handleEditPayee,
	handleEditChaps,
	canAddMultiplePayees,
}) => (
	<div className="account-picker__items" data-cy="payee-list">
		{!pageLoading &&
			payees.length > 0 &&
			payees.map((payee) => (
				<div className={`account-picker__items__item ${cardClass}`} key={payee.id} data-cy="payee-card">
					<PayeeCardSelector
						listViewSelected={listViewSelected}
						handlePayeeSelect={handlePayeeSelect}
						getIsPayeeSelected={getIsPayeeSelected}
						isManageYourPayee={isManageYourPayee}
						handleViewPayee={handleViewPayee}
						handleDeletePayee={handleDeletePayee}
						handleEditPayee={handleEditPayee}
						handleEditChaps={handleEditChaps}
						payee={payee}
						canAddMultiplePayees={canAddMultiplePayees}
					/>
				</div>
			))}
	</div>
);

PayeePickerPage.propTypes = {
	pageLoading: PropTypes.bool.isRequired,
	payees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes).isRequired),
	listViewSelected: PropTypes.bool.isRequired,
	handlePayeeSelect: PropTypes.func.isRequired,
	getIsPayeeSelected: PropTypes.func,
	cardClass: PropTypes.string.isRequired,
	isManageYourPayee: PropTypes.bool,
	handleViewPayee: PropTypes.func,
	handleDeletePayee: PropTypes.func,
	handleEditPayee: PropTypes.func,
	canAddMultiplePayees: PropTypes.bool,
};

export default PayeePickerPage;
